import React, { useState, useEffect } from 'react';
import { Modal, Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import StartupRegister from '../auth/StartupRegister';
import startupApi from '../../api/startupApi';

const EditStartupProfile = ({ visible, onClose, onSuccess, startupData: initialData }) => {
  const [loading, setLoading] = useState(false);
  const [startupData, setStartupData] = useState(null);

  useEffect(() => {
    if (visible) {
      if (initialData) {
        // Use the data passed as prop
        setStartupData(initialData);
      } else {
        // Fetch data if not provided
        fetchStartupData();
      }
    }
  }, [visible, initialData]);

  const fetchStartupData = async () => {
    try {
      setLoading(true);
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      
      if (userInfo.startup) {
        const data = await startupApi.getStartupProfile(userInfo.startup);
        setStartupData(data);
      }
    } catch (error) {
      message.error('Failed to load startup data');
      console.error('Error fetching startup data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    message.success('Startup profile updated successfully');
    onSuccess();
    onClose();
  };

  return (
    <Modal
      title={
        <span style={{ 
          fontSize: '20px', 
          fontWeight: 500, 
          color: '#3C007A',
          fontFamily: "'Rubik', sans-serif"
        }}>
          Edit Startup Profile
        </span>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width="90%"
      style={{ maxWidth: '900px', top: 20 }}
      bodyStyle={{ 
        maxHeight: 'calc(90vh - 110px)', 
        overflowY: 'auto',
        padding: '24px'
      }}
      destroyOnClose
    >
      {loading ? (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '200px' 
        }}>
          <Spin 
            indicator={<LoadingOutlined style={{ fontSize: 48, color: '#3C007A' }} spin />} 
          />
        </div>
      ) : (
        <StartupRegister
          onSuccess={handleSuccess}
          isAdminEdit={true}
          selfEdit={true}
          editingStartup={startupData}
        />
      )}
    </Modal>
  );
};

export default EditStartupProfile;
